"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var taxCartNormalizer = function (data) {
    var taxObject = {
        taxAmount: data.tax_amount || 0,
        taxRate: data.tax_rate || 0,
        includedVATRate: data.included_vat_rate || 0,
        includedVATAmount: data.included_vat_amount || 0,
    };
    return taxObject;
};
var taxNormalizer = function (data) {
    var taxObject = {
        taxAmount: data.tax_amount || 0,
        taxRate: data.tax_rate || 0,
        includedVATRate: data.included_vat_rate || 0,
        includedVATAmount: data.included_vat_amount || 0,
    };
    if (data.cart) {
        var normalizedCart_1 = {};
        Object.keys(data.cart).forEach(function (key) {
            var obj = data.cart[key];
            if (obj) {
                normalizedCart_1[key] = taxCartNormalizer(obj);
            }
        });
        taxObject.cart = normalizedCart_1;
    }
    return { data: taxObject };
};
exports.default = taxNormalizer;
